module.exports = __webpack_public_path__ + "img/spec_logo.47a23aee.png";